import { useMutation, useQueryClient } from "react-query";
import { crearSolicitud, crearSolicitudExcel, updateSolicitud, deleteSolicitud} from '../../services/Solicitudes';
import { toast } from 'react-hot-toast';

const queryKey = "proyectos";

export const useSolicitudesMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };

  const addSolicitudExcel = useMutation((body) => crearSolicitudExcel(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

    const addSolicitud = useMutation((body) => crearSolicitud(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const updateSolicitudC = useMutation(
    (body) => updateSolicitud( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeSolicitud = useMutation((id) => deleteSolicitud( id), {
    onSuccess,
    onError,
  });

  return { addSolicitud, addSolicitudExcel, updateSolicitudC, removeSolicitud };
};
export default useSolicitudesMutations;